import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import getTitle from '@/utils/getTitle'
import { filterAuthorizedRoutes } from '@/utils/AuthorizedRoutes'
import { isPC } from "@/utils/browser";
import { Message } from 'element-ui' // 引用element-ui的加载和消息提示组件

Vue.use(Router)
import Layout from '@/layout'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}


// 全部路由
export const currencyRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login'),
    meta: { 'title': '登录页' },
    hidden: true
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/error-page/404.vue'),
    meta: { 'title': '错误页面' },
    hidden: true
  },
  {
    path: '/',
    name: 'Home',
    component: Layout,
    // redirect: '/orders/order',
    redirect: '/dashbord',
    children: [
      {
        path: 'dashbord',
        name: 'Dashbord',
        component: () => import('@/views/welcome/index.vue'),
        meta: { title: '首页', icon: 'el-icon-s-home' },
      },
      {
        path: 'password',
        name: 'Password',
        component: () => import('@/views/password/index.vue'),
        meta: { title: '修改密码', icon: 'el-icon-edit' },
      }
    ]
  },


]
export const authRoutes = [
  {
    path: '/orders',
    name: 'OrderMenu',
    component: Layout,
    redirect: '/orders/order',
    meta: {
      title: '订单',
      icon: 'el-icon-folder',
    },
    children: [
      {
        path: 'order',
        name: 'Order',
        component: () => import('@/views/order/order'),
        meta: {
          title: '订单查询',
          icon: 'el-icon-search'
        },
      },
      {
        path: 'refundLog',
        name: 'RefundLog',
        component: () => import('@/views/order/refund-log/refund-log'),
        meta: {
          title: '退款日志',
          icon: 'el-icon-s-order'
        },
      },
    ]
  },
  {
    path: '/statics',
    name: 'Statics',
    component: Layout,
    redirect: '/statics/analyzeSelf',
    meta: {
      title: '数据',
      icon: 'el-icon-data-analysis',
    },
    isAuth: true, // 要授权
    children: [
      {
        path: 'analyzeSelf', // ['05601','05633','05634','05608','50333','50338', '50339', 'admin', '50160']这些用户才能看到
        name: 'AnalyzeSelf',
        component: () => import('@/views/static/analyze_v2'),
        meta: {
          title: '数据看板',
          icon: 'el-icon-s-data'
        },
        isAuth: true
      },
      {
        path: 'statistics',
        name: 'Statistics',
        component: () => import('@/views/statistics/statistics'),
        meta: {
          title: '数据统计',
          icon: 'el-icon-data-line'
        },
        isAuth: true
      },
      {
        path: 'inventory',
        name: 'Inventory',
        component: () => import('@/views/static/inventory'),
        meta: {
          title: '库存异常',
          icon: 'el-icon-folder-delete'
        },
        isAuth: true
      },
      // {
      //   path: 'screening',
      //   name: 'screening',
      //   component: () => import('@/views/screening/screening.vue'),
      //   meta: {
      //     title: '数据总览',
      //     icon: 'el-icon-user-solid'
      //   },
      //   isAuth: true
      // },
    ]
  },
  {
    path: '/map',
    name: 'Map',
    component: Layout,
    redirect: '/map/mapdisplay',
    meta: {
      title: '地图',
      icon: 'el-icon-search',
    },
    isAuth: true, // 要授权
    children: [
      // {
      //   path: 'mapdisplay',
      //   name: 'Mapdisplay',
      //   component: () => import('@/views/demo/mapdemo.vue'),
      //   meta: {
      //     title: '地图展示',
      //     icon: 'el-icon-magic-stick'
      //   },
      //   isAuth: true
      // },
      {
        path: 'mapdisplay',
        name: 'Mapdisplay',
        component: () => import('@/views/demo/demo6'),
        meta: {
          title: '地图展示',
          icon: 'el-icon-magic-stick'
        },
        isAuth: true
      },
      {
        path: 'globalData',
        name: 'GlobalData',
        component: () => import('@/views/demo/demo9'),
        meta: {
          title: '全球数据',
          icon: 'el-icon-magic-stick'
        },
        isAuth: false
      },
      // {
      //   path: 'screening',
      //   name: 'screening',
      //   component: () => import('@/views/screening/screening.vue'),
      //   meta: {
      //     title: '数据总览',
      //     icon: 'el-icon-user-solid'
      //   },
      //   isAuth: true
      // },
    ]
  },
]

export const phoneCurrencyRoutes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/phoneIndex',
    hidden: true
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login'),
    meta: { 'title': '登录页' },
    hidden: true
  },


]

export const phoneAuthRoutes = [
  {
    path: '/phoneIndex',
    name: 'phoneIndex',
    redirect: '/phoneIndex/phoneOrder',
    component: () => import('@/views/phone/index.vue'),
    meta: {
      'title': '详情页',
    },
    children: [
      {
        path: 'phoneOrder',
        name: 'phoneOrder',
        component: () => import('@/views/phone/order.vue'),
        meta: {
          'title': '订单查询',
        },
        isAuth: false
      },
      {
        path: 'phoneStatic',
        name: 'phoneStatic',
        component: () => import('@/views/phone/static.vue'),
        meta: {
          'title': '数据统计',
        },
        isAuth: true
      },
      {
        path: 'phone_deviceNum',
        name: 'phone_deviceNum',
        component: () => import('@/views/phone/deviceNum.vue'),
        meta: {
          'title': '设备离线状态',
        },
        isAuth: true
      }
    ]
  },
]

const creatRouter = () => {
  return new Router({
    routes: isPC() ? currencyRoutes : phoneCurrencyRoutes,
    mode: 'history',
    scrollBehavior() {
      return { x: 0, y: 0 }
    }
  })
}
const router = creatRouter()
export default router


// 导航守卫
router.beforeEach(async (to, from, next) => {
  document.title = getTitle(to.meta.title)
  if (to.path === '/login') {
    next()
  } else {
    if (to.query && to.query.secretkey) {
      // 这里加入从别人系统免密进入的情况
      await store.dispatch('user/_getRsa', { data: decodeURIComponent(to.query.secretkey) })
    }
    if (store.getters.token) {
      const hasRoles = store.getters.roles.length > 0
      console.log(hasRoles)
      if (hasRoles) {
        if (to.name === null) {
          next({
            path: '/404',
            query: {
              redirect: to.fullPath
            }
          })
        } else {
          next()
        }
      } else {
        try {
          const res = await store.dispatch('user/_getInfo')
          if (!res.data) {
            Message.error(res.msg)
            next({
              path: '/login',
              query: {
                redirect: to.fullPath
              }
            })
          } else {
            // console.log(res.data.MenuList);
            // 把有权限的路由进行过滤
            const authorizedRoutes = res.data.MenuList;

            // 改写authorizedRoutes
            let tempAuthorizedRoutes = [];
            for (let val of authorizedRoutes) {
              tempAuthorizedRoutes.push(val.name)
            }
            const allRoutes = isPC() ? authRoutes : phoneAuthRoutes;
            const authMenu = filterAuthorizedRoutes(allRoutes, tempAuthorizedRoutes);
            // console.log(authMenu)
            router.addRoutes(authMenu); // 把有权限的路由添加进去
            // console.log(router.getRoutes())
            if (isPC()) {
              store.commit('permission/SET_ROUTES', authMenu); // 把获取到的路由列表更新到store中，routes后期需要增加过滤的
              localStorage.setItem('routes', JSON.stringify(authMenu)) // 防止用户刷新页面，存入到本地缓存中
               next({ ...to, replace: true })
            } else {
              localStorage.setItem('routes', JSON.stringify(phoneAuthRoutes)) // 防止用户刷新页面，存入到本地缓存中
              if (to.path == "/phoneIndex") {
                const name = phoneAuthRoutes[0].children[0].path
                router.push({
                  path: `/phoneIndex/${name}`,
                })
              }else{
                next({ ...to, replace: true })
              }
            }
          }
        } catch (error) {
          // 如果是401错误，axios拦截器已经处理了跳转，这里不需要重复处理
          if (error.response && error.response.status === 401) {
            // 401错误由axios拦截器处理，这里直接返回
            return
          }
          Message.error(error.msg || error.message || '获取用户信息失败')
          // 其他错误跳转到登录页
          next({
            path: '/login',
            query: {
              redirect: to.fullPath
            }
          })
        }
      }

    } else {
      console.log(to)
      next({
        path: '/login',
        query: {

        }
      })
    }
  }
})

